module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ScreenLayout', [_c('div', {
    staticClass: "white-background",
    staticStyle: {
      "position": "relative",
      "display": "flex",
      "flex-direction": "column",
      "height": "100%"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "white responsive-boundary",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FormBlock', {
    ref: "block",
    attrs: {
      "schema": _vm.scenarioSchema,
      "context": _vm.formContext
    },
    on: {
      "change": _vm.formChanged
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa-4 white",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v("\n\n        " + _vm._s(_vm.formContext.focusedField) + "\n        "), _c('Activities', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "activities": _vm.someComments
    }
  }), _vm._v(" "), _vm._l((_vm.requests), function(request) {
    return _c('div', {
      key: request._id
    }, [_vm._v("\n            " + _vm._s(request.name) + "\n            "), _c('div', {
      staticClass: "light-text"
    }, [_vm._v("\n                " + _vm._s(_vm.policyAsText(request.policy)) + "\n            ")])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c4bc956"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dc/Checklist.vue
// module id = 2491
// module chunks = 1